import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { TruckGroup } from '../../../truck-group.model';
import { AppServerAPI } from '@sdbn/common';
import { Station } from '../../../../../client/model/station';
import { TabComponent } from '@sdbn/common';

@Component({
  selector: 'app-truck-group-condition-selection',
  templateUrl: './truck-group-condition-selection.component.html',
  styleUrls: ['./truck-group-condition-selection.component.scss']
})
export class TruckGroupConditionSelectionComponent implements OnInit {





  avaiableStations = new Set<Station>();

  assignableStations: Station[];

  assignedStations = new Set<Station>();

  selectedAvaiableStations = new Set<Station>();

  selectedAssignedStations = new Set<Station>();


  included = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TruckGroup,
    public dialogRef: MatDialogRef<TruckGroupConditionSelectionComponent>,
    private appServerAPI: AppServerAPI,
  ) {


  }

  ngOnInit() {
    this.loadStations();
  }

  private loadStations() {
    this.appServerAPI.execute<Station[]>('/client/admin/truckgroup/getstations', {}).subscribe((results) => {
      console.log(results);
      const stations = new Array<Station>();
      for (const result of results) {
        const station = new Station(result);
        stations.push(station);
      }
      this.assignableStations = stations;

      for (const station of stations) {
        this.avaiableStations.add(station);
      }
    })
  }

  selectAvaiableStations(station: Station) {
    this.selectedAssignedStations.clear()
    if (this.selectedAvaiableStations.has(station)) {
      this.selectedAvaiableStations.delete(station);
      return;
    }

    this.selectedAvaiableStations.add(station);
  }

  addStation() {
    for (const station of this.selectedAvaiableStations) {
      this.assignedStations.add(station);
      this.avaiableStations.delete(station);
    }
    this.selectedAvaiableStations.clear();
  }
  removeStation() {
    for (const station of this.selectedAssignedStations) {
      this.avaiableStations.add(station);
      this.assignedStations.delete(station);
    }
    this.selectedAssignedStations.clear();
  }

  selectAssignedStations(station: Station) {
    this.selectedAvaiableStations.clear()
    if (this.selectedAssignedStations.has(station)) {
      this.selectedAssignedStations.delete(station);
    } else {
      this.selectedAssignedStations.add(station);
    }
  }

  handleActiveTab(event: TabComponent) {
    if (event.key == 'include') {
      this.included == true;
    } else {
      this.included = false;
    }

  }

  onConfirm() {
    this.dialogRef.close({
      included: this.included,
      assignedStations: Array.from(this.assignableStations.map(value => value.id)).sort()
    });
  }

  onCancel() {
    this.dialogRef.close(null);
  }
}
